<template>
    <div class="full-content rounded-b bg-neutral-darker text-white text-sm py-lg md:py-xl">
        <div class="flex flex-col md:flex-row items-center md:justify-between lg:justify-end">
            <div class="w-full flex px-sm mb-xl md:w-auto md:mr-2xl lg:mr-4xl md:mb-0">
                <div>
                    <div class="mb-sm">{{ lang('Månadskostnad', 'Monthly cost') }}</div>
                    <div class="text-md font-semibold">{{ monthlyPrice }}</div>
                </div>
                <div class="ml-xl md:ml-4xl">
                    <div class="mb-sm">{{ lang('Engångskostnad', 'Initial cost') }}</div>
                    <div class="text-md font-semibold">{{ oneTimeCost }}</div>
                </div>
            </div>
            <button
                v-tooltip="tooltipText"
                class="btn btn-lg"
                type="button"
                :class="{ 'is-fake-disabled': ! validates, 'is-primary': validates }"
                @click="addToCart"
            >
                {{ btnText }}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            monthlyPrice: {
                type: String,
                required: true,
            },
            oneTimeCost: {
                type: String,
                required: true,
            },
            validates: {
                type: Boolean,
                required: true,
            },
            btnText: {
                type: String,
                default: translation('services_blocks_btn_add_to_cart'),
            },
        },
        computed: {
            tooltipText() {
                if (! this.validates) {
                    return lang(
                        'Alla val är inte ifyllda, fyll i dessa så kan du därefter lägga produkten i varukorgen',
                        'All required options not selected, please select required options to proceed'
                    );
                }

                return null;
            },
        },
        methods: {
            addToCart() {
                if (! this.validates) {
                    return;
                }

                this.$emit('add');
            },
        },
    };
</script>
